import Cookies from 'js-cookie';
import {
  AdminUsersIcon,
  ClosuresIcon,
  QuestionsIcon,
  ReportsIcon,
  ShapesIcon,
  AdminUsersActiveIcon,
  ClosuresActiveIcon,
  QuestionsActiveIcon,
  ReportsActiveIcon,
  ShapesActiveIcon,
  ManageCertificate,
  ManageCertificateActiveIcon,
  ResourcesIcon,
  ResourcesActiveIcon
} from '../Universal/Assets';
import { NavbarMenuItem } from '../CommonTypes';

export { default as PAStateBoundary } from './Pennsylvania_State_Boundary.json';

export const clearJwtCookie = () => {
  Cookies.remove('access');
  Cookies.remove('refresh');
  Cookies.remove('isValidated');
};

export const clearJwtLocalStorage = () => {
  localStorage.removeItem('isLoggedIn');
  if (localStorage.getItem('selectedClosure'))
    localStorage.removeItem('selectedClosure');
  if (localStorage.getItem('selectedTab'))
    localStorage.removeItem('selectedTab');
  if (localStorage.getItem('server_time'))
    localStorage.removeItem('server_time');
};

export const api_prefix = '/api/vl/';

export const maxVerticesInClosure = 100;
export const minVerticesInClosure = 3;
export const maxNumberOfPolygonsInClosure = 5;

export const PA_BOUNDARY = {
  north: 43.911776256500175,
  south: 37.42037948979245,
  west: -81.22109335488982,
  east: -73.82729452676482
};

export const navbarMenuItems: NavbarMenuItem[] = [
  {
    name: 'Closures',
    src: ClosuresIcon,
    activeSrc: ClosuresActiveIcon,
    link: '/ClosureEvent',
    page: 'Closures',
    alt: 'Closures Icon'
  },
  {
    name: 'Question Library',
    src: QuestionsIcon,
    activeSrc: QuestionsActiveIcon,
    link: '/QuestionLibrary',
    page: 'Questions',
    alt: 'Question Library Icon'
  },
  {
    name: 'Shapes Library',
    src: ShapesIcon,
    activeSrc: ShapesActiveIcon,
    link: '/ShapesLibrary',
    page: 'Shapes',
    alt: 'Shapes Library Icon'
  },
  {
    name: 'Manage Users',
    src: AdminUsersIcon,
    activeSrc: AdminUsersActiveIcon,
    link: '/ManageUsers',
    page: 'AdminUsers',
    alt: 'Manage Users Icon'
  },
  {
    name: 'After Action Reports',
    src: ReportsIcon,
    activeSrc: ReportsActiveIcon,
    link: '/AfterActionReports',
    page: 'Reports',
    alt: 'After Action Reports Icon'
  },
  {
    name: 'Resources',
    src: ResourcesIcon,
    activeSrc: ResourcesActiveIcon,
    link: '/Resources',
    page: 'Resources',
    alt: 'Resources Icon'
  },
  {
    name: 'Manage Certificate',
    src: ManageCertificate,
    activeSrc: ManageCertificateActiveIcon,
    link: '/ManageCertificate',
    page: 'Certificate',
    alt: 'Manage Certificate Icon'
  }
];

export const MapFilterIntervalTime = 10000;

export const COGDetailsIntervalTime = 1200000;

export const questionsLibraryTableRowLimit = 10;

export const monthsListDropdownOptions = [
  { value: '0', label: 'January' },
  { value: '1', label: 'February' },
  { value: '2', label: 'March' },
  { value: '3', label: 'April' },
  { value: '4', label: 'May' },
  { value: '5', label: 'June' },
  { value: '6', label: 'July' },
  { value: '7', label: 'August' },
  { value: '8', label: 'September' },
  { value: '9', label: 'October' },
  { value: '10', label: 'November' },
  { value: '11', label: 'December' }
];

export const getYearDropdownOptions = (
  startYear: number = 2020,
  endYear: number = new Date().getFullYear()
) => {
  const yearListDropdownOptions: Array<{ value: number; label: string }> = [];
  for (let year = startYear; year <= endYear; year++) {
    yearListDropdownOptions.push({ value: year, label: year.toString() });
  }
  return yearListDropdownOptions;
};

export const RegisteredUsersTableRowLimit = 15;

export const MessagesTableRowLimit = 20;

export const InputMaxLength = 2000;

export const RestrictedCharactersofEventId = [
  '|',
  '\\',
  '/',
  '^',
  '~',
  '’',
  "'",
  '"',
  '(',
  ')',
  '{',
  '}',
  '[',
  ']',
  ',',
  ' ',
  '>',
  '<',
  '&'
];
